import React, { PropsWithChildren } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { routes } from './constants/routes';
import Login from './containers/Login';
import Register from './containers/Register';
import ResetPassword from './containers/ResetPassword';
import ForgotPassword from './containers/ForgotPassword';
import MainLayout from './components/layouts/MainLayout';
import HomeScreen from './containers/Tabs/Home';
import RoutesScreen from './containers/Tabs/Routes';
import CalendarScreen from './containers/Tabs/Calendar';
import ProfileScreen from './containers/Tabs/Profile';
import RouteScreen from './containers/Route';
import Content from './containers/Content';
import RecordsLayout from './components/layouts/RecordsLayout';
import DailyIntro from './containers/Records/DailyIntro';
import DailyEmotion from './containers/Records/DailyEmotion';
import DailyReason from './containers/Records/DailyReason';
import DailyTips from './containers/Records/DailyTips';
import DailyFinish from './containers/Records/DailyFinish';
import WelcomeScreen from './containers/Welcome';
import ChangePasswordScreen from './containers/ChangePassword';
import Admin from './containers/Admin';
import CompleteContent from './containers/CompleteContent';
import theme from './constants/theme';
import { getAccessToken } from './utils/tokenStorage';

export const RequireAuth: React.FC<PropsWithChildren> = ({ children }) => {
  const isAuthenticated = getAccessToken();
  return isAuthenticated ? <>{children}</> : <Navigate to={routes.welcome} />;
};

function App() {
  return (
    <div className="app" style={{ backgroundColor: theme.colors.background.primary }}>
      <Routes>
        <Route path={routes.root} element={<MainLayout />}>
          <Route index element={<HomeScreen />} />
          <Route path={routes.routes.root}>
            <Route index element={<RoutesScreen />} />
            <Route path={routes.routes.detail} element={<RouteScreen />} />
            <Route path={routes.routes.content.detail} element={<Content />} />
            <Route path={routes.routes.content.complete} element={<CompleteContent />} />
          </Route>
          <Route path={routes.calendar} element={<CalendarScreen />} />
          <Route path={routes.profile} element={<ProfileScreen />} />
        </Route>
        <Route path={routes.records.root} element={<RecordsLayout />}>
          <Route path={routes.records.daily.intro} element={<DailyIntro />} />
          <Route path={routes.records.daily.emotion} element={<DailyEmotion />} />
          <Route path={routes.records.daily.reason} element={<DailyReason />} />
          <Route path={routes.records.daily.tips} element={<DailyTips />} />
          <Route path={routes.records.daily.finish} element={<DailyFinish />} />
        </Route>
        <Route path={routes.welcome} element={<WelcomeScreen />} />
        <Route path={routes.login} element={<Login />} />
        <Route path={routes.register} element={<Register />} />
        <Route path={routes.forgot_password.reset} element={<ResetPassword />} />
        <Route path={routes.forgot_password.root} element={<ForgotPassword />} />
        <Route path={routes.changePassword} element={<ChangePasswordScreen />} />
        <Route path={`${routes.admin.root}/*`} element={<Admin />} />
        <Route path="*" element={<Navigate to={routes.welcome} />} />
      </Routes>
    </div>
  );
}

export default App;
